module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_3016.8222a12f.png";